import { closeAddDeviceIfOpen } from "@/features/add-device/close-add-device-flow";
import type { INFO_CARD_TYPE } from "@/features/cards/shared/card-routing/card-types";
import type MapEntityBase from "@/services/map-management/map-entities/map-entity-base";
import { useStore } from "@/store/store";

// Kept in its own leaf module to break an import cycle: `close-add-device-flow` imports from
// card-routing (`card-types`), so if this opener lived in `card-config`/`use-card-slot` it would
// form card-routing → close-add-device-flow → card-routing. As a standalone file it stays a leaf.
// TODO: Remove once we migrate the Add Device card to Zustand, use openCard from state directly instead. No need for explicit close for Add Device
export function openZustandCard({
    entity,
    cardType,
    initialPanelKey,
}: {
    entity?: MapEntityBase;
    cardType: INFO_CARD_TYPE;
    initialPanelKey?: string;
}): void {
    closeAddDeviceIfOpen().catch((e) => {
        console.warn("Error closing add device flow", e);
    });
    useStore.getState().openCard({ entity, cardType, initialPanelKey });
}
